import cache from "memory-cache";

export const getFromCacheByKey = (key: string): any => {
  return cache.get(key);
};

export const setInCacheByKey = (key: string, data: any, time: number): void => {
  cache.put(key, data, time);
};

